<div class="card overflow-hidden" style="min-width: 12rem">
	<div class="bg-holder bg-card"
		style="background-image:url('../assets/images/material/corner-{{card.type}}.png');">
	</div><!--/.bg-holder-->
	<div class="card-body position-relative">
		<h6 class="fw-semi-bold">{{card.title}}<span *ngIf="card.summary.length>0" class="badge badge-subtle-{{card.type}} rounded-pill ms-2 {{card.summaryIcon ? 'material-icons':''}}">{{card.summary}}</span></h6>
		<div class="display-4 fs-5 mb-2 fw-normal font-sans-serif text-{{card.type}}">
			{{card.count}}&nbsp;&nbsp;
			<span *ngIf="card.icon !=''" class="ms-1 material-icons">{{card.icon}}</span>
			
		</div>
		<a class="fw-semi-bold fs-10 text-nowrap" href="{{card.link}}">
			{{card.link_name}}
			<span class="ms-1 material-icons">chevron_right</span>
		</a>
	</div>
</div>